import actionTypes from './vlite.actionTypes';
import initialStates from './vlite.initialStates';

const vliteReducer = (state = initialStates, { type, payload }) => {
  switch (type) {
    case actionTypes.USER_LOGIN_START:
      return {
        ...state,
        isLoggedIn: false,
        member: null,
        errorMessage: null,
      };
    case actionTypes.USER_LOGIN_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
        member: payload,
      };

    case actionTypes.USER_LOGIN_ERROR:
      return {
        ...state,
        isLoggedIn: false,
        errorMessage: payload,
      };

    case actionTypes.USER_LOGOUT:
      return {
        ...state,
        isLoggedIn: false,
        member: null,
      };

    case actionTypes.SET_SIDEBAR_VISIBILITY:
      return {
        ...state,
        isSidebarVisible: payload,
      };
    case actionTypes.SET_SIDEBAR_OPEN:
      return {
        ...state,
        isSidebarOpen: payload,
      };
    case actionTypes.SET_CHANGEPASSWORD_OPEN:
      return {
        ...state,
        isChangePasswordOpen: payload,
      };
    case actionTypes.SET_CHANGEEMAIL_OPEN:
      return {
        ...state,
        isChangeEmailOpen: payload,
      };

    case actionTypes.SET_PREV_PATH:
      return {
        ...state,
        prevPath: payload,
      };

    default:
      return state;
  }
};

export default vliteReducer;
